<div class="PGUserWidget">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading && userData != null) {
        <div>
            <div><b>{{ 'pg-user-widget.user' | locTranslate }}</b> {{formatUserLabel()}}</div>
        </div>
    }
</div>
